module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_11.d33f3e5f.jpg";